import { GetAsync } from 'common/httpRequests';
import { BACKEND } from 'constants/settings';

export async function GetVersionId() {
  const response = await GetAsync(
    `${BACKEND}/api/notificationservice/Notifications/customer/refresh-state`
  );
  return response?.data?.documentsRefreshId;
}

export async function GetNotifications() {
  const response = await GetAsync(
    `${BACKEND}/api/notificationservice/Notifications/customer/portal`
  );
  return response?.data;
}
